import {createSlice} from '@reduxjs/toolkit';
//types
import {IAdminNotificationSettingReducer} from '@/utils/types/superAdmin.interface';
//actions
import {adminGetNotificationSettings, adminUpdateNotificationSettings} from './actions';
//operations
import {pendingOperation, rejectedOperation, getNotificationSetting, updateNotificationSetting} from './operations';

export const initialState: IAdminNotificationSettingReducer = {
	adminSetting: null,
	isLoading: false,
};

const adminNotificationStore = createSlice({
	name: 'adminNotification',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(adminGetNotificationSettings.pending, pendingOperation);
		builder.addCase(adminGetNotificationSettings.fulfilled, getNotificationSetting);
		builder.addCase(adminGetNotificationSettings.rejected, rejectedOperation);

		builder.addCase(adminUpdateNotificationSettings.pending, pendingOperation);
		builder.addCase(adminUpdateNotificationSettings.fulfilled, updateNotificationSetting);
		builder.addCase(adminUpdateNotificationSettings.rejected, rejectedOperation);
	},
});

export default adminNotificationStore.reducer;
